// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizCompanyDataInTable_cont__29W9J","img":"BizCompanyDataInTable_img__1MdoO","info":"BizCompanyDataInTable_info__3Y9rR","nm":"BizCompanyDataInTable_nm__2L_vK"};